import { CheckoutData, CartItem, OrderItem, Service } from "@lemmonhq/types";

export type CheckoutItem = CartItem | OrderItem;

export function getCheckoutItems(checkout: CheckoutData): CheckoutItem[] {
  if (checkout.payload?.type === "cart") {
    return checkout.payload.object.items;
  } else if (checkout.payload?.type === "table") {
    const tableCheckout = checkout.payload.object;
    return tableCheckout.orders.flatMap((order) => order.items || []);
  }
  return [];
}

export function getItemProductId(item: CheckoutItem): number {
  if ("productId" in item) {
    return item.productId; // CartItem
  } else {
    return item.product_id; // OrderItem
  }
}

export function getItemQuantity(item: CheckoutItem): number {
  return item.quantity;
}

export function getProductIdsFromCategories(
  services: Service[],
  categoryIds: number[],
): number[] {
  const productIds: number[] = [];

  for (const service of services) {
    if (service.categories) {
      for (const category of service.categories) {
        if (categoryIds.includes(category.id)) {
          productIds.push(...(category.product_ids || []));
        }
      }
    }
  }

  return [...new Set(productIds)]; // Remove duplicates
}
